import { apiServer } from "../config/config";
import { fetchWithToken } from "./fetchWithToken";

/** A single tag inside a "matters to you" group. */
export interface MattersToYouOption {
  id: number;
  name: string;
}

/**
 * One row of the onboarding "Tell us what matters to you" step. Selecting the
 * group means the user cares about all of its `children` tags.
 */
export interface MattersToYouGroup {
  group_name: string;
  /** Phosphor icon name in kebab-case, e.g. `speaker-simple-slash`. */
  icon: string;
  children: MattersToYouOption[];
}

export interface SubmitAccessibility {
  userId: number;
  ability: string;
  how_do_you_hear_about_us_ids: string;
  accessibility_need_selection: string;
  makeDisabilityVisibleValue: boolean;
  accessibilityFeatureRequestTagsValue: string;
}

export async function fetchAccessibilities() {
  const response = await fetch(apiServer + "/accessibility/load");
  const data = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data;
}

export async function submitAccessibility(args: SubmitAccessibility) {
  console.log("submitAccessibility", args);
  const response = await fetch(apiServer + "/user/register-update", {
    method: "POST", // Specify the request method
    headers: {
      "Content-Type": "application/json", // Set the content type of the request
    },
    body: JSON.stringify(args), // Convert the JavaScript object to a JSON string
  });
  const data = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data;
}

export async function postProfileUserAccessibility(
  abilities: string,
  need: string,
  accessToken: string
) {
  const formData = new FormData();
  formData.append("ability", abilities);
  formData.append("accessibility_need_selection", need);
  const response = await fetchWithToken(apiServer + "/user/profile-user-accessibility", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  const data = await response?.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data;
}
